import { useCallback, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./priceSummary.gql";
import { useSelector } from "react-redux";

const flattenData = (data) => {
  if (!data) return {};
  return {
    subtotal: data.cart.prices.subtotal_excluding_tax,
    total: data.cart.prices.grand_total,
    discounts: data.cart.prices.discounts,
    giftCards: data.cart.applied_gift_cards,
    taxes: data.cart.prices.applied_taxes,
    shipping: data.cart.shipping_addresses,
  };
};

export const usePriceSummary = (props = {}) => {
  const location = useLocation();
  const [couponCodeText, setCouponCodeText] = useState("");
  const { getPriceSummaryQuery } = DEFAULT_OPERATIONS;

  const { cartId } = useSelector((state) => state.cartSlice);

  const navigate = useNavigate();
  const match = location.pathname === "/checkout";
  const isCheckout = !!match;

  const { error, loading, data } = useQuery(getPriceSummaryQuery, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    skip: !cartId,
    variables: {
      cartId,
    },
  });

  const handleProceedToCheckout = useCallback(() => {
    navigate("/checkout");
  }, [navigate]);

  return {
    handleProceedToCheckout,
    hasError: !!error,
    hasItems: data && !!data.cart.items.length,
    isCheckout,
    isLoading: !!loading,
    flatData: flattenData(data),
    couponCodeText,
    setCouponCodeText,
    data,
  };
};
